define(function() {
    var map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      '\'': '&#039;',
    };

    return {
      escapeHtml: function(text) {
        return text.replace(/[&<>"']/g, function(m) { return map[m]; });
      },
    };
});
